// extracted by mini-css-extract-plugin
module.exports = {"orderDetails":"order-details_orderDetails__oW3LT"};